<div class="page-title">
    <h1>Crie lives e vídeos interativos para vender mais</h1>
</div>
<div class="grid">
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <span class="font-semibold text-lg"><i class="pi pi-video mr-2"></i> Tempo de conteúdo</span>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{ contentTime }}</span>
                        <div class="text-green-500">
                            <span class="font-medium">
                                <span *ngIf="percentageTime == 0">
                                    -
                                </span>
                                <span *ngIf="percentageTime > 0">
                                    +{{ percentageTime | number:'1.0-2' }} <i class="pi pi-arrow-up"></i>
                                </span>

                                <!-- Para porcentagem negativa -->
                                <span *ngIf="percentageTime < 0">
                                    {{ percentageTime | number:'1.0-2' }} <i class="pi pi-arrow-down"></i>
                                </span>
                            </span>
                            <!-- Exibe a seta para cima se o número for maior que zero -->
                            <!-- <i *ngIf="(porcentagemAprovadas ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemAprovadas ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <span class="font-semibold text-lg"><i class="pi pi-clock mr-2"></i> Tempo assistido</span>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{ timeWatched.toFixed(2) }}% </span>
                        <div class="text-green-500">
                            <span class="font-medium">
                                <span *ngIf="percentageWatched == 0">
                                    -
                                </span>
                                <span *ngIf="percentageWatched > 0">
                                    +{{ percentageWatched | number:'1.0-2' }} <i class="pi pi-arrow-up"></i>
                                </span>

                                <!-- Para porcentagem negativa -->
                                <span *ngIf="percentageWatched < 0">
                                    {{ percentageWatched | number:'1.0-2' }} <i class="pi pi-arrow-down"></i>
                                </span>
                            </span>
                            <!-- <i *ngIf="(porcentagemAguardando ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemAguardando ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->


                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <span class="font-semibold text-lg"><i class="pi pi-users mr-2"></i> Espectadores</span>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{ countEspectadores }}</span>

                        <div class="text-pink-500">
                            <span class="font-medium">
                                <span *ngIf="percentageEspectadores == 0">
                                    -
                                </span>
                                <span *ngIf="percentageEspectadores > 0">
                                    +{{ percentageEspectadores | number:'1.0-2' }} <i class="pi pi-arrow-up"></i>
                                </span>

                                <!-- Para porcentagem negativa -->
                                <span *ngIf="percentageEspectadores < 0">
                                    {{ percentageEspectadores | number:'1.0-2' }} <i class="pi pi-arrow-down"></i>
                                </span>
                            </span>
                            <!-- <i *ngIf="(porcentagemExpiradas ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemExpiradas ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->

                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
    <div class="col-12 md:col-6 xl:col-3">
        <div class="card h-full">
            <ng-container *ngIf="!loading; else loadingTemplate">
                <!-- <ng-container> -->
                <span class="font-semibold text-lg"><i class="pi pi-heart mr-2"></i> Curtidas</span>
                <div class="flex justify-content-between align-items-start mt-3">
                    <div class="w-12">
                        <span class="text-4xl font-bold text-900">{{ countLikes }}</span>
                        <div class="text-green-500">
                            <span class="font-medium">
                                <span *ngIf="percentageLikes == 0">
                                    -
                                </span>
                                <span *ngIf="percentageLikes > 0">
                                    +{{ percentageLikes | number:'1.0-2' }} <i class="pi pi-arrow-up"></i>
                                </span>

                                <!-- Para porcentagem negativa -->
                                <span *ngIf="percentageLikes < 0">
                                    {{ percentageLikes | number:'1.0-2' }} <i class="pi pi-arrow-down"></i>
                                </span>
                            </span>
                            <!-- <i *ngIf="(porcentagemCanceladas ?? 0) > 0" class="pi pi-arrow-up text-xs ml-2"></i>
                            <i *ngIf="(porcentagemCanceladas ?? 0) < 0" class="pi pi-arrow-down text-xs ml-2"></i> -->

                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #loadingTemplate>
                <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                <p-skeleton width="100%" height="1rem"></p-skeleton>
                <p-skeleton width="60%" height="1rem"></p-skeleton>
            </ng-template>
        </div>
    </div>
</div>
<div class="grid">
    <div class="col-12">
        <div class="card">
            <!-- <h5>DataView</h5> -->
            <!-- <p-dataView #dvD [value]="products" [paginator]="true" [rows]="9" filterBy="name" [sortField]="sortField"
                [sortOrder]="sortOrder" layout="grid">
                <ng-template pTemplate="header">
                    <div class="flex flex-column md:flex-row md:justify-content-between gap-2">
                        <p-dropdown [options]="sortOptions" placeholder="Sort By Price"
                            (onChange)="onSortChange($event)"></p-dropdown>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input type="search" pInputText placeholder="Search by Name" (input)="onFilter(dv, $event)">
                        </span>
                        <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
                    </div>
                </ng-template>

                <ng-template let-product pTemplate="listItem">
                    <div class="col-12">
                        <div class="flex flex-column md:flex-row align-items-center p-3 w-full">
                            <img [src]="'assets/demo/images/product/' + product.image" [alt]="product.name"
                                class="my-4 md:my-0 w-9 md:w-10rem shadow-2 mr-5" />
                            <div class="flex-1 flex flex-column align-items-center text-center md:text-left">
                                <div class="font-bold text-2xl">{{product.name}}</div>
                                <div class="mb-2">{{product.description}}</div>
                                <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"
                                    styleClass="mb-2"></p-rating>
                                <div class="flex align-items-center mt-2">
                                    <i class="pi pi-tag mr-2"></i>
                                    <span class="font-semibold">{{product.category}}</span>
                                </div>
                            </div>
                            <div
                                class="flex flex-row md:flex-column justify-content-between w-full md:w-auto align-items-center md:align-items-end mt-5 md:mt-0">
                                <span
                                    class="text-2xl font-semibold mb-2 align-self-center md:align-self-end">${{product.price}}</span>
                                <p-button icon="bi bi-cart3" label="Add to Cart"
                                    [disabled]="product.inventoryStatus === 'OUTOFSTOCK'"
                                    styleClass="mb-2 p-button-sm"></p-button>
                                <span
                                    [class]="'product-badge status-' + product.inventoryStatus.toLowerCase()">{{product.inventoryStatus}}</span>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template let-product pTemplate="gridItem">
                    <div class="col-12 md:col-4">
                        <div class="card m-3 border-1 surface-border">
                            <div class="flex flex-wrap gap-2 align-items-center justify-content-between mb-2">
                                <div class="flex align-items-center">
                                    <i class="pi pi-tag mr-2"></i>
                                    <span class="font-semibold">{{product.category}}</span>
                                </div>
                                <span
                                    [class]="'product-badge status-' + product.inventoryStatus.toLowerCase()">{{product.inventoryStatus}}</span>
                            </div>
                            <div class="flex flex-column align-items-center text-center mb-3">
                                <img [src]="'assets/demo/images/product/' + product.image" [alt]="product.name"
                                    class="w-9 shadow-2 my-3 mx-0" />
                                <div class="text-2xl font-bold">{{product.name}}</div>
                                <div class="mb-3">{{product.description}}</div>
                                <p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating>
                            </div>
                            <div class="flex align-items-center justify-content-between">
                                <span class="text-2xl font-semibold">${{product.price}}</span>
                                <p-button icon="bi bi-cart3"
                                    [disabled]="product.inventoryStatus === 'OUTOFSTOCK'"></p-button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-dataView> -->

            <p-dataView #dv [value]="filteredAssets" [paginator]="true" [rows]="9" filterBy="name"
                emptyMessage="Nenhum resultado encontrado" [rowsPerPageOptions]="[9, 18, 90]" [sortField]="sortField"
                [sortOrder]="sortOrder" layout="grid">
                <ng-template pTemplate="header">
                    <div class="header-scrollable">
                        <div class="flex flex-column md:flex-row md:justify-content-between gap-2 mb-2">
                            <p-dataViewLayoutOptions></p-dataViewLayoutOptions>

                            <!-- p-calendar para fazer -->
                            <p-calendar [(ngModel)]="rangeDates" [ngStyle]="{'max-width': '245px', 'min-width': '245px'}"
                                selectionMode="range" (onSelect)="onDateSelect()" [showIcon]="true"></p-calendar>

                            <!-- p-dropdown que busca por live ou shorts -->
                            <p-dropdown [options]="typeOptions" [(ngModel)]="selectedType" (onChange)="onTypeSelect()"
                                placeholder="Selecione o tipo"></p-dropdown>

                            <!-- busca por ao vivo -->
                            <p-dropdown [options]="streamStatusOptions" [(ngModel)]="selectedStreamStatus"
                                (onChange)="onStreamStatusSelect()" placeholder="Select Stream Status"></p-dropdown>

                            <!-- busca por ao publicado -->
                            <p-dropdown [options]="statusOptions" [(ngModel)]="selectedStatus"
                                (onChange)="onStatusSelect()" placeholder="Select Status"></p-dropdown>

                            <!-- busca por nome -->
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input type="search" [(ngModel)]="searchTerm" style="max-width: 185px;" pInputText
                                    placeholder="Buscar por nome" (input)="onFilterSlicks($event)">
                            </span>

                            <!-- <button pButton pRipple (click)="clearFilter()"
                            [disabled]="!rangeDates || rangeDates.length === 0" icon="pi pi-filter-slash 2"
                            class="flex clear-button mb-2 p-button-outlined "></button> -->
                            <button pButton pRipple style="    min-width: 45px;" (click)="clearFilter()" icon="pi pi-filter-slash 2"
                                class="flex clear-button  p-button-outlined "></button>


                            <div class="ss-g-right-section">
                                <button pButton pRipple label="Criar Slick"
                                    class="p-button-primary-500 text-white b1 mr-1"></button>
                                <button pButton pRipple type="button" icon="pi pi-chevron-down"
                                    (click)="menu.toggle($event)"
                                    class="p-element p-ripple p-datepicker-trigger p-button-icon-only p-button p-component"></button>
                                <p-menu #menu [popup]="true" appendTo="body"></p-menu>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template let-asset pTemplate="listItem">
                    <div class="col-12" *ngFor="let item of asset.items">
                        <!-- Adaptação do template de lista para os items do asset -->
                        <div class="flex flex-column md:flex-row align-items-center p-3 w-full">
                            <img [src]="'assets/img.jpg'" class="my-4 md:my-0 w-9 md:w-10rem shadow-2 mr-5" />
                            <!-- Substitua com campos relevantes do item -->
                            <div class="flex-1 flex flex-column align-items-center text-center md:text-left">
                                <div class="font-bold text-2xl">{{item.content.title}}</div>
                                <div class="mb-2">{{item.content.description}}</div>
                                <!-- Mais campos do item conforme necessário -->
                            </div>
                        </div>
                    </div>
                </ng-template>

                <ng-template let-asset pTemplate="gridItem">
                    <div class="col-12 md:col-4" *ngFor="let item of asset.items">
                        <!-- Adaptação do template de grid para os items do asset -->
                        <div class="card m-3 border-1 surface-border">
                            <div class="flex flex-wrap gap-2 align-items-center justify-content-between mb-2">
                                <div class="flex align-items-center">
                                    <i class="pi pi-tag mr-2"></i>
                                    <span class="font-semibold">{{item.content.title}}</span>
                                </div>
                                <span [class]="'product-badge status-'">Instock</span>
                            </div>
                            <div class="text-center">
                                <img [src]="'assets/img.jpg'" class="w-9 md:w-10rem shadow-2 my-4" />
                            </div>
                            <div class="flex flex-column align-items-center text-center mb-3">
                                <div class="text-2xl font-bold">{{item.content.title}}</div>
                                <div class="mb-3">{{item.content.description}}</div>
                                <!-- Mais campos do item conforme necessário -->
                            </div>
                        </div>
                    </div>
                </ng-template>

            </p-dataView>

        </div>
    </div>
</div>